import { forwardRef } from 'react'
import { cva } from 'class-variance-authority'
import cn from 'clsx'
import { VisuallyHidden } from '../visually-hidden'
import type { TIconButtonProps } from './IconButton.types'
import styles from './IconButton.module.css'

/** Exported for anchors — see `buttonClassNames`. */
export const iconButtonClassNames = cva(styles.iconButton, {
    variants: {
        variant: {
            outline: styles['variant-outline'],
            solid: styles['variant-solid'],
            inverse: styles['variant-inverse'],
            experiment: styles['variant-experiment'],
            embed: styles['variant-embed'],
        },
        size: {
            labeled: styles['size-labeled'],
            icon: styles['size-icon'],
        },
    },
    defaultVariants: { variant: 'outline', size: 'icon' },
})

export const IconButton = forwardRef<HTMLButtonElement, TIconButtonProps>(
    ({ className, variant = 'outline', size = 'icon', Icon, srLabel, children, ...props }, ref) => {
        const icon = typeof Icon === 'function' ? <Icon className={styles.icon} /> : Icon

        return (
            <button
                ref={ref}
                type="button"
                className={cn(iconButtonClassNames({ variant, size }), className)}
                {...props}
            >
                {icon}
                {srLabel ? <VisuallyHidden>{srLabel}</VisuallyHidden> : null}
                {children}
            </button>
        )
    },
)
